import {
  Question,
  QuestionnaireAnswers,
  QuestionType,
  IntenseExerciseMinutes,
  SleepHours,
  FruitVegServings,
  AlcoholConsumption,
  SmokerStatus,
  FamilyHistoryCondition,
  YesNoAnswer,
  ConditionsCount,
  MentalWellbeingFrequency,
} from "./types";

export const MOCK_LIFESTYLE_QUESTIONS: Question[] = [
  {
    type: QuestionType.INTENSE_EXERCISE,
    meta: {
      values: [
        IntenseExerciseMinutes.ZERO_TO_150,
        IntenseExerciseMinutes.ONE_FIFTY_TO_300,
        IntenseExerciseMinutes.THREE_HUNDRED_PLUS,
      ],
    },
  },
  {
    type: QuestionType.SLEEP,
    meta: {
      values: [
        SleepHours.LESS_THAN_7,
        SleepHours.SEVEN_TO_9,
        SleepHours.MORE_THAN_9,
      ],
    },
  },
  {
    type: QuestionType.FRUIT_VEG_CONSUMPTION,
    meta: {
      values: [
        FruitVegServings.ONE,
        FruitVegServings.TWO,
        FruitVegServings.THREE,
      ],
    },
  },
  {
    type: QuestionType.ALCOHOL_CONSUMPTION,
    meta: {
      values: [
        AlcoholConsumption.NONE,
        AlcoholConsumption.ONE,
        AlcoholConsumption.TWO,
        AlcoholConsumption.TWO_PLUS,
      ],
    },
  },
  {
    type: QuestionType.SMOKER_STATUS,
    meta: {
      values: [SmokerStatus.NEVER, SmokerStatus.STOPPED, SmokerStatus.REGULAR],
    },
  },
];

export const MOCK_LIFESTYLE_INITIAL_ANSWERS: QuestionnaireAnswers = {
  [QuestionType.INTENSE_EXERCISE]: {
    type: QuestionType.INTENSE_EXERCISE,
    meta: {
      value: IntenseExerciseMinutes.ONE_FIFTY_TO_300,
      performedStrengthExercises: true,
    },
  },
  [QuestionType.SLEEP]: {
    type: QuestionType.SLEEP,
    meta: {
      value: SleepHours.SEVEN_TO_9,
    },
  },
  [QuestionType.FRUIT_VEG_CONSUMPTION]: {
    type: QuestionType.FRUIT_VEG_CONSUMPTION,
    meta: {
      value: FruitVegServings.TWO,
    },
  },
  [QuestionType.ALCOHOL_CONSUMPTION]: {
    type: QuestionType.ALCOHOL_CONSUMPTION,
    meta: {
      value: AlcoholConsumption.ONE,
    },
  },
  [QuestionType.SMOKER_STATUS]: {
    type: QuestionType.SMOKER_STATUS,
    meta: {
      value: SmokerStatus.NEVER,
    },
  },
};

export const MOCK_HEALTH_HISTORY_QUESTIONS: Question[] = [
  {
    type: QuestionType.FAMILY_HISTORY,
    multiSelect: true,
    meta: {
      values: [
        FamilyHistoryCondition.DIABETES,
        FamilyHistoryCondition.HIGH_BLOOD_PRESSURE,
        FamilyHistoryCondition.CORONARY_ARTERY_DISEASE,
        FamilyHistoryCondition.NONE,
      ],
    },
  },
  {
    type: QuestionType.FAMILY_TUBERCULOSIS,
    meta: {
      values: [YesNoAnswer.YES, YesNoAnswer.NO],
    },
  },
  {
    type: QuestionType.CONDITIONS,
    meta: {
      values: [
        ConditionsCount.NONE,
        ConditionsCount.ONE,
        ConditionsCount.TWO_PLUS,
      ],
    },
  },
  {
    type: QuestionType.HIV_TB,
    meta: {
      values: [YesNoAnswer.YES, YesNoAnswer.NO],
    },
  },
];

export const MOCK_HEALTH_HISTORY_INITIAL_ANSWERS: QuestionnaireAnswers = {
  [QuestionType.FAMILY_HISTORY]: {
    type: QuestionType.FAMILY_HISTORY,
    meta: {
      value: {
        [FamilyHistoryCondition.DIABETES]: true,
        [FamilyHistoryCondition.HIGH_BLOOD_PRESSURE]: false,
        [FamilyHistoryCondition.CORONARY_ARTERY_DISEASE]: true,
      },
    },
  },
  [QuestionType.FAMILY_TUBERCULOSIS]: {
    type: QuestionType.FAMILY_TUBERCULOSIS,
    meta: {
      value: YesNoAnswer.NO,
    },
  },
  [QuestionType.CONDITIONS]: {
    type: QuestionType.CONDITIONS,
    meta: {
      value: ConditionsCount.ONE,
    },
  },
  [QuestionType.HIV_TB]: {
    type: QuestionType.HIV_TB,
    meta: {
      value: YesNoAnswer.NO,
    },
  },
};

const MENTAL_WELLBEING_FREQUENCY_VALUES = [
  MentalWellbeingFrequency.NOT_AT_ALL,
  MentalWellbeingFrequency.SEVERAL_DAYS,
  MentalWellbeingFrequency.MORE_THAN_HALF,
  MentalWellbeingFrequency.NEARLY_EVERYDAY,
];

export const MOCK_MENTAL_WELLBEING_QUESTIONS: Question[] = [
  {
    type: QuestionType.NERVOUS_OR_ON_EDGE,
    meta: {
      description: true,
      values: MENTAL_WELLBEING_FREQUENCY_VALUES,
    },
  },
  {
    type: QuestionType.UNCONTROLLABLE_WORRY,
    meta: {
      description: true,
      values: MENTAL_WELLBEING_FREQUENCY_VALUES,
    },
  },
  {
    type: QuestionType.LOW_INTEREST_OR_PLEASURE,
    meta: {
      description: true,
      values: MENTAL_WELLBEING_FREQUENCY_VALUES,
    },
  },
  {
    type: QuestionType.FEELING_DOWN_OR_HOPELESS,
    meta: {
      description: true,
      values: MENTAL_WELLBEING_FREQUENCY_VALUES,
    },
  },
];

export const MOCK_MENTAL_WELLBEING_INITIAL_ANSWERS: QuestionnaireAnswers = {
  [QuestionType.NERVOUS_OR_ON_EDGE]: {
    type: QuestionType.NERVOUS_OR_ON_EDGE,
    meta: { value: MentalWellbeingFrequency.NOT_AT_ALL },
  },
  [QuestionType.UNCONTROLLABLE_WORRY]: {
    type: QuestionType.UNCONTROLLABLE_WORRY,
    meta: { value: MentalWellbeingFrequency.NOT_AT_ALL },
  },
  [QuestionType.LOW_INTEREST_OR_PLEASURE]: {
    type: QuestionType.LOW_INTEREST_OR_PLEASURE,
    meta: { value: MentalWellbeingFrequency.SEVERAL_DAYS },
  },
  [QuestionType.FEELING_DOWN_OR_HOPELESS]: {
    type: QuestionType.FEELING_DOWN_OR_HOPELESS,
    meta: { value: MentalWellbeingFrequency.NOT_AT_ALL },
  },
};
